export default __webpack_public_path__ + "fb90f54.png";